import { useState, type FormEvent } from "react";
import { useNavigate } from "react-router-dom";
import { authApi, setToken } from "@/lib/api";
import Footer from "@/pages/home/components/Footer";

export default function LoginPage() {
  const navigate = useNavigate();

  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [status, setStatus] = useState<"idle" | "submitting" | "error">("idle");
  const [errorMsg, setErrorMsg] = useState("");

  const handleLogin = async (e: FormEvent) => {
    e.preventDefault();
    if (!username.trim() || !password.trim()) {
      setStatus("error");
      setErrorMsg("아이디와 비밀번호를 모두 입력해 주세요.");
      return;
    }

    setStatus("submitting");
    setErrorMsg("");

    try {
      const data = await authApi.login(username.trim(), password);

      setToken(data.token);
      navigate("/admin/dashboard", { replace: true });
    } catch (err: unknown) {
      setStatus("error");
      const msg = err instanceof Error ? err.message : "로그인에 실패했습니다.";
      setErrorMsg(msg);
    }
  };

  return (
    <>
      <main className="min-h-screen bg-background-50 flex items-center justify-center pt-20 pb-16">
        <div className="w-full max-w-md mx-auto px-6">
          <div className="text-center mb-10">
            <div className="inline-flex items-center gap-2 text-primary-700 text-xs tracking-[0.3em] uppercase font-medium mb-4">
              <span className="w-8 h-px bg-primary-500"></span>
              Admin Access
            </div>
            <h1 className="font-heading text-3xl font-bold text-foreground-950">
              관리자 로그인
            </h1>
            <p className="mt-3 text-foreground-600 text-sm">
              장비 및 갤러리 관리를 위해 로그인이 필요합니다.
            </p>
          </div>

          <div className="rounded-lg bg-background-100/60 border border-background-200/70 p-8">
            <form onSubmit={handleLogin} className="space-y-5">
              <div>
                <label htmlFor="login-username" className="block text-sm font-medium text-foreground-800 mb-2">
                  아이디
                </label>
                <input
                  id="login-username"
                  name="username"
                  type="text"
                  autoComplete="username"
                  required
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  placeholder="관리자 아이디"
                  className="w-full h-12 px-4 rounded-md bg-background-50 border border-background-200 focus:border-primary-500 focus:outline-none text-sm text-foreground-950 placeholder:text-foreground-400"
                />
              </div>
              <div>
                <label htmlFor="login-password" className="block text-sm font-medium text-foreground-800 mb-2">
                  비밀번호
                </label>
                <input
                  id="login-password"
                  name="password"
                  type="password"
                  autoComplete="current-password"
                  required
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="········"
                  className="w-full h-12 px-4 rounded-md bg-background-50 border border-background-200 focus:border-primary-500 focus:outline-none text-sm text-foreground-950 placeholder:text-foreground-400"
                />
              </div>

              {status === "error" && (
                <div className="p-4 rounded-md bg-accent-100 border border-accent-300 text-accent-900 text-sm flex items-start gap-2">
                  <i className="ri-error-warning-line text-lg w-5 h-5 flex items-center justify-center flex-shrink-0"></i>
                  {errorMsg}
                </div>
              )}

              <button
                type="submit"
                disabled={status === "submitting"}
                className="w-full h-12 rounded-md bg-primary-500 hover:bg-primary-600 text-background-50 dark:text-foreground-950 font-medium text-sm tracking-wide transition-colors cursor-pointer whitespace-nowrap disabled:opacity-70 flex items-center justify-center gap-2"
              >
                {status === "submitting" ? (
                  <>
                    <i className="ri-loader-4-line animate-spin w-4 h-4 flex items-center justify-center"></i>
                    로그인 중...
                  </>
                ) : (
                  <>
                    <i className="ri-lock-line w-4 h-4 flex items-center justify-center"></i>
                    로그인
                  </>
                )}
              </button>
            </form>

            <div className="mt-6 pt-5 border-t border-background-200/70">
              <p className="text-xs text-foreground-500 text-center">
                관리자 계정은 서버에서 별도로 생성합니다.
              </p>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
}